import BaseSider from "@/components_v2/Sider/BaseSider";
import SidebarContent from "./SidebarContent";
import type { SidebarProps } from "./types";

import "./styles.css";

const Sidebar = ({
  currentUser,
  isCollapsed,
  onToggleCollapsed,
}: SidebarProps) => {
  return (
    <BaseSider
      collapsed={isCollapsed}
      collapsedWidth={72}
      width={250}
      trigger={null}
      className={`side-menu ${isCollapsed ? "side-menu-collapsed" : "side-menu-expanded"}`}
    >
      <SidebarContent
        currentUser={currentUser}
        isCollapsed={isCollapsed}
        showCollapseTrigger
        onToggleCollapsed={onToggleCollapsed}
      />
    </BaseSider>
  );
};

export default Sidebar;
